import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyVal',
})
export class CurrencyValPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return Math.abs(+value) > 999
      ? parseFloat((Math.abs(+value) / 1000).toFixed(1)) + 'k'
      : Math.abs(+value);
  }
}
